'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PushCartTopBar = PushCartTopBar;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function PushCartTopBar(_ref) {
  var title = _ref.title,
      cartTotalOverview = _ref.cartTotalOverview;

  var itemCount = (0, _reactRedux.useSelector)(function (state) {
    return state.pushCart.itemCount;
  });

  return _react2.default.createElement('div', { className: 'psh-TopBar' }, _react2.default.createElement('h4', { className: 'psh-Topbar_Title' }, title), _react2.default.createElement('span', { className: 'psh-Topbar_CartCount' }, itemCount, ' ', cartTotalOverview), _react2.default.createElement('button', { type: 'button', className: 'psh-TopBar_Close', 'data-module-drawers-close': 'cart' }, _react2.default.createElement('svg', { viewBox: '0 0 20 19', xmlns: 'http://www.w3.org/2000/svg' }, _react2.default.createElement('g', { fillRule: 'evenodd' }, _react2.default.createElement('path', { d: 'M19.546 2.075l-16.97 16.97-2.122-2.12 16.97-16.97z' }), _react2.default.createElement('path', { d: 'M2.575-.046l16.97 16.97-2.12 2.122L.455 2.076z' })))));
}

PushCartTopBar.propTypes = {
  title: _propTypes2.default.string.isRequired,
  cartTotalOverview: _propTypes2.default.string.isRequired
};